import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import relativeTime from 'dayjs/plugin/relativeTime';

const configure = () => {
  dayjs.extend(relativeTime);
};

dayjs.locale('nl');

const service = {
  configure,
  dayjs,
};

export default service;
